import { Dispatch } from "react";
import { Action } from "../types";
import { MAP_TYPE_IDS } from "../../components/FlotiMap/data";

export type SimpleFleet = {
  fleetid: number
  name: string
}

export type Preference = {
  DEFAULT_LANDING_SITE: string
  CUSTOM_STOP_LIMIT: number
  DISABLE_ZOOM_AND_DRAG: boolean
  HIDE_STOPS_HISTORY: boolean
  MAP_FULLSCREEN_ON_LOAD: boolean
  MAP_LATITUDE_ON_LOAD: number
  MAP_LONGITUDE_ON_LOAD: number
  MAP_ZOOM_LEVEL_ON_LOAD: number
  SELECTED_FLEET: number
  SELECTED_MOBILE: number
  BASELAYER: MAP_TYPE_IDS
  ENABLE_CLUSTER: boolean
  LANGUATE: string
}

export enum PreferenceKey {
  SELECTED_DASHBOARDS = 'SELECTED_DASHBOARDS',
  SELECTED_FLEET = 'SELECTED_FLEET',
  LANGUATE = 'LANGUAGE',
  MOBILE_OR_DRIVER = 'MOBILE_OR_DRIVER',
  SELECTED_DRIVER = 'SELECTED_DRIVER',
  SELECTED_MOBILE = 'SELECTED_MOBILE',
  BASELAYER = 'BASELAYER',
  SELECTED_LAYERS = 'SELECTED_LAYERS',
  ENABLE_CLUSTER = 'ENABLE_CLUSTER',
  DEFAULT_LANDING_SITE = 'DEFAULT_LANDING_SITE',
  SELECTED_ROUTE = 'SELECTED_ROUTE',
  MAP_FULLSCREEN_ON_LOAD = 'MAP_CULLSCREEN_ON_LOAD',
  EMAIL_ON_POSREP_FAILURE	= 'EMAIL_ON_POSREP_FAILURE',
  MAP_ZOOM_LEVEL_ON_LOAD = 'MAP_ZOOM_LEVEL_ON_LOAD',
  MAP_LATITUDE_ON_LOAD = 'MAP_LATITUDE_ON_LOAD',
  MAP_LONGITUDE_ON_LOAD	= 'MAP_LONGITUDE_ON_LOAD',
  CUSTOM_STOP_LIMIT	= 'CUSTOM_STOP_LIMIT',
  HIDE_STOPS_HISTORY = 'HIDE_STOPS_HISTORY',
  DISABLE_ZOOM_AND_DRAG	= 'DISABLE_ZOOM_AND_DRAG'
}

export enum PreferencePatchKey {
  SELECTED_DASHBOARDS = 'selected_dashboards',
  SELECTED_FLEET = 'selected_fleet',
  LANGUATE = 'language',
  MOBILE_OR_DRIVER = 'mobile_or_driver',
  SELECTED_DRIVER = 'selected_driver',
  SELECTED_MOBILE = 'selected_mobile',
  BASELAYER = 'baselayer',
  SELECTED_LAYERS = 'selected_layers',
  ENABLE_CLUSTER = 'enable_cluster',
  DEFAULT_LANDING_SITE = 'default_landing_site',
  SELECTED_ROUTE = 'selected_route',
  MAP_FULLSCREEN_ON_LOAD = 'map_fullscreen_on_load',
  EMAIL_ON_POSREP_FAILURE	= 'email_on_posrep_failure',
  MAP_ZOOM_LEVEL_ON_LOAD = 'map_zoom_level_on_load',
  MAP_LATITUDE_ON_LOAD = 'map_latitude_on_load',
  MAP_LONGITUDE_ON_LOAD	= 'map_longitude_on_load',
  CUSTOM_STOP_LIMIT	= 'custom_stop_limit',
  HIDE_STOPS_HISTORY = 'hide_stops_history',
  DISABLE_ZOOM_AND_DRAG	= 'disable_zoom_and_drag'
}

type Permissions = {
  trackwell?: Record<string, boolean>
  auth?: Record<string, boolean>
  fleet?: Record<string, boolean>
}

export type UserState = {
  name: string
  username: string
  id: string
  first_name: string
  last_name: string
  initialized: false
  access_token?: string
  refresh_token?: string
  language: string
  groups: string[]
  permissions: Permissions
  main_fleet?: number
  email?: string
  available_fleets: SimpleFleet[]
  preferences?: Preference
}

export type Token = {
  refresh: string
  access: string
}

export type User = {
  name: string
  username: string
  first_name: string
  last_name: string
  language: string
  groups: string[]
  permissions: Permissions
  main_fleet?: number
  email?: string
}

export type UserContext = {
  user: UserState
  dispatch: Dispatch<Action>
}
